import { defaultFill } from '../../utils/constants';
var muiPage16 = {
    paths: [
        {
            path: 'M2,14 L10,14 L10,5 L7,5 L7,2 L2,2 L2,14 Z M0,1.00087166 C0,0.448105505 0.453036308,0 0.997030139,0 L8,0 L12,4 L12,14.9975267 C12,15.5511774 11.544239,16 10.9975267,16 L1.00247329,16 C0.448822582,16 0,15.5553691 0,14.9991283 L0,1.00087166 Z',
            fill: defaultFill,
        },
    ],
    title: 'Page',
    width: 12,
    height: 16,
};
var muiPage24 = {
    paths: [
        {
            path: 'M11,2 L2,2 L2,22 L16,22 L16,7 L11,7 L11,2 Z M18,6 L18,23 C18,23.5522847 17.5522847,24 17,24 L1,24 C0.44771525,24 0,23.5522847 0,23 L0,1 C0,0.44771525 0.44771525,0 1,0 L12,0 C12,0 18,6.02889588 18,6 Z M5,7 L8,7 C8.55228475,7 9,6.55228475 9,6 C9,5.44771525 8.55228475,5 8,5 L5,5 C4.44771525,5 4,5.44771525 4,6 C4,6.55228475 4.44771525,7 5,7 Z M5,11 L13,11 C13.5522847,11 14,10.5522847 14,10 C14,9.44771525 13.5522847,9 13,9 L5,9 C4.44771525,9 4,9.44771525 4,10 C4,10.5522847 4.44771525,11 5,11 Z M5,15 L13,15 C13.5522847,15 14,14.5522847 14,14 C14,13.4477153 13.5522847,13 13,13 L5,13 C4.44771525,13 4,13.4477153 4,14 C4,14.5522847 4.44771525,15 5,15 Z M5,19 L13,19 C13.5522847,19 14,18.5522847 14,18 C14,17.4477153 13.5522847,17 13,17 L5,17 C4.44771525,17 4,17.4477153 4,18 C4,18.5522847 4.44771525,19 5,19 Z',
            fill: defaultFill,
        },
    ],
    title: 'Page',
    width: 18,
    height: 24,
};
var muiPage = {
    base: muiPage16,
    smIcon: muiPage16,
    lgIcon: muiPage24,
};
export { muiPage };
//# sourceMappingURL=page.js.map